export const cloneTracker = (trackerInstance, usageTrackerLocation) => {
  return trackerInstance.clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: 'Ai Addon Copilot Preview',
    properties: {
      screen: usageTrackerLocation
    }
  });
};